const $win = $(window);
const $variantsHolder = $(".product__variants");
const headerHeight = $(".header").height();
const $body = $("body");

function init() {
  if ($win.scrollTop() + headerHeight > $variantsHolder.offset().top && $win.width() < 768) {
    $body.addClass("product-fixed-cart");
  } else {
    $body.removeClass("product-fixed-cart");
  }
}

$win.on("scroll load", function() {
  if ($variantsHolder.length) {
    init();
  }
});



// WEBPACK FOOTER //
// ../assets/js/product_fixed_cart.js